document.addEventListener('DOMContentLoaded', () => {
  // --- Avis du héros : défilement doux d’un avis à la fois ---
  const avis = document.querySelector('[data-kk-avis]');
  if (avis) {
    const items = Array.from(avis.querySelectorAll('[data-kk-avis-item]'));
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (items.length > 1 && !reduce) {
      let current = 0;
      let timer = null;
      const show = (next) => {
        items[current].classList.remove('is-active');
        items[current].setAttribute('aria-hidden', 'true');
        current = (next + items.length) % items.length;
        items[current].classList.add('is-active');
        items[current].removeAttribute('aria-hidden');
      };
      const start = () => { timer = window.setInterval(() => show(current + 1), 3500); };
      const stop = () => { if (timer) { window.clearInterval(timer); timer = null; } };
      avis.addEventListener('mouseenter', stop);
      avis.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      start();
    }
  }

  // --- Lightbox aperçus recettes ---
  const overlay = document.querySelector('[data-kk-lightbox-overlay]');
  if (overlay) {
    const overlayImg = overlay.querySelector('[data-kk-lightbox-img]');
    const closeBtn = overlay.querySelector('[data-kk-lightbox-close]');
    let opener = null;

    const openLightbox = (href, alt) => {
      if (!href) return;
      overlayImg.src = href;
      overlayImg.alt = alt || '';
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    };
    const closeLightbox = () => {
      overlay.hidden = true;
      overlayImg.removeAttribute('src');
      overlayImg.alt = '';
      document.body.style.overflow = '';
      opener?.focus();
      opener = null;
    };

    document.querySelectorAll('[data-kk-lightbox]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        opener = link;
        const img = link.querySelector('img');
        openLightbox(link.getAttribute('href'), img ? img.alt : '');
      });
    });

    closeBtn.addEventListener('click', closeLightbox);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeLightbox();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) closeLightbox();
    });
  }

  const buyBar = document.querySelector('[data-ebook-mobile-buy-bar]');
  const primaryButton = document.querySelector('[data-ebook-primary-buy]');

  if (!buyBar || !primaryButton || !window.IntersectionObserver) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const footer = document.querySelector('footer');
  let primaryVisible = true;
  let footerVisible = false;

  const updateBuyBar = () => {
    buyBar.hidden = !mobileQuery.matches || primaryVisible || footerVisible;
  };

  const primaryObserver = new IntersectionObserver(
    ([entry]) => {
      primaryVisible = entry.isIntersecting;
      updateBuyBar();
    },
    { threshold: 0.15 }
  );

  primaryObserver.observe(primaryButton);

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        footerVisible = entry.isIntersecting;
        updateBuyBar();
      },
      { threshold: 0.05 }
    );

    footerObserver.observe(footer);
  }

  mobileQuery.addEventListener('change', updateBuyBar);
  updateBuyBar();
});
